import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

if (window.tarteaucitron) {
  window.tarteaucitron.user.posthogApiKey = "phc_DbsPb39SRc8z3EiQ6Dhj6ikv4H4rTKcht9d4sZSesceP";
  window.tarteaucitron.user.posthogHost = "https://ap.emergent.sh";
  (window.tarteaucitron.job = window.tarteaucitron.job || []).push("posthog");
  window.tarteaucitron.init({
    privacyUrl: "/confidentialite",
    bodyPosition: "top",
    hashtag: "#cookies",
    cookieName: "mastoras-cookies",
    orientation: "bottom",
    groupServices: true,
    showDetailsOnClick: true,
    serviceDefaultState: "wait",
    showAlertSmall: false,
    cookieslist: true,
    closePopup: true,
    showIcon: false,
    iconPosition: "BottomRight",
    adblocker: false,
    DenyAllCta: true,
    AcceptAllCta: true,
    highPrivacy: true,
    handleBrowserDNTRequest: false,
    removeCredit: false,
    moreInfoLink: true,
    useExternalCss: false,
    mandatory: true,
    mandatoryCta: true,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
